<template>
<div :id="componentId">
  <div class="toolbar mb8">
    <select class="custom-select" v-model="selectedRoadName"
        @change="onChangeRoadName">
      <option v-for="e in roadNames" :value="e.key" :key="e.key">
        {{e.val}}
      </option>
    </select>
    <sort-button class="ib sort-bt1 ml4" @sort="onSortKey1Sort"
        :toggle-type="sort.sortKey1.toggleType">
      ｿｰﾄ番号
    </sort-button>
  </div>
  <div :id="listWrapId" class="list-wrap">
    <b-list-group class="selectable">
      <b-list-group-item v-for="e in displayedPoleMasters" :key="e.register_id"
        :id="listItemId(e)"
        :class="getListItemClz(e)"
        @click="onListItemClick(e)"
        v-html="itemDisp(e)">
      </b-list-group-item>
    </b-list-group>
  </div>
  <div class="mt10">
    <div class="ta-right count-info" v-if="countInfo.totalCount">
      <span class="mr4">完了数</span>
      <span class="done-count">{{countInfo.doneCount}}</span>
      <span class="slash ml2 mr2">/</span>
      <span class="total-count">{{countInfo.totalCount}}</span>
    </div>
  </div>
  <pager class="mt8" v-show="false"
    :item-count="itemCount"
    :items-per-page="itemsPerPage"
    :page-range="1"
    :margin-pages="0"
    :force-page="currentPage - 1"
    @click="onChangePage"
  ></pager>
</div>
</template>

<script>
import Vue from 'vue'
import sortMixin from '@/mixin/sortMixin'
import * as eventNames from '@/consts/eventNames'
import * as sortStates from '@/consts/sortStates'

export default {
  name: 'pole-master-list',
  props: {
    src: {
      type: Array,
      default() {
        return []
      }
    },
    dispType: {
      type: String,
      default: 'full',
    },
    stream: {
      type: Object,
    }
  },
  data() {
    return {
      isReady: false,

      filteredPoleMasters: [],
      displayedPoleMasters: [],
      poleMastersByRoadName: {},
      poleMasterMap: {}, // by pole_number
      selectedPoleMastersMap: {},

      selectedPolesMap: {},

      sort: {
        sortKey1: {
          toggleType: sortStates.TOGGLE_TYPE_AD,
          state: sortStates.SORT_STATE_ASC,
        }
      },

      roadNames: [],
      selectedRoadName: '',

      onResizeFunc: null,

      itemsPerPage: 10000, // no paging
      currentPage: 1,

      countInfo: {
        doneCount: 0,
        totalCount: 0,
      }
    }
  },
  computed: {
    componentId() {
      return 'pole-master-list-' + this._uid
    },
    listWrapId() {
      return 'list-wrap-' + this._uid
    },
    itemCount() {
      return this.filteredPoleMasters.length
    },
    isSelectedPolesEmpty() {
      return Object.keys(this.selectedPolesMap).length === 0
    },
    isSelectedPoleMastersEmpty() {
      return Object.keys(this.selectedPoleMastersMap).length === 0
    },
  },
  watch: {
    src() {
      const { poleMastersByRoadName, poleMasterMap, roadNames } =
        this.convPoleMasters(this.src.slice())
      this.poleMastersByRoadName = poleMastersByRoadName
      this.poleMasterMap = poleMasterMap
      this.roadNames = roadNames

      let prms = Promise.resolve()
      if (!this.selectedRoadName) {
        prms = this.$store.dispatch(
          'localStorage/get',
          { key: 'selectedRoadNamePoleMaster' }
        ).then(name => {
          this.selectedRoadName = name || this.roadNames[0].key
        })
      }
      prms.then(() => {
        this.isReady = true
        this.onChangeRoadName()
      })
    },
  },
  mixins: [sortMixin],
  mounted() {
    this.initResizeFunc()
    this.setListeners()
  },
  destroyed() {
    window.removeEventListener('resize', this.onResizeFunc)
  },
  methods: {
    listItemId(e) {
      return `list-item-${e.register_id}-${this._uid}`
    },
    getListItemClz(e) {
      // order matters
      const arr = []
      if (e.is_attached) {
        arr.push('attached')
      }
      if (this.selectedPoleMastersMap[e.pole_number]) {
        arr.push('selected')
      }
      return arr.join(' ')
    },
    initResizeFunc() {
      this.onResizeFunc = () => {
        const h = window.innerHeight - 170
        const elem = document.getElementById(this.listWrapId)
        elem.style.height = `${h}px`
      }
      this.onResizeFunc()
      window.addEventListener('resize', this.onResizeFunc)
    },
    setListeners() {
      this.stream.recv(eventNames.SELECT_POLES,
        ({ poles }) => {
          if (!this.isReady) { return }
          if (!poles) { return }
          const obj = poles.reduce((acc, e) => {
            acc[e.id] = e; return acc
          }, {})
          this.selectedPolesMap = obj
          this.setPoleMasterSelections(poles)
          this.scrollToItemByPole(poles[0])
        }
      )
      this.stream.recv(eventNames.UNSELECT_POLES,
        ({ poles }) => {
          if (!this.isReady) { return }
          if (!poles) { return }
          poles.forEach(e => {
            Vue.delete(this.selectedPolesMap, e.id)
          })
          this.clearPoleMasterSelections()
        }
      )
      this.stream.recv(eventNames.UPDATED_POLE_MASTERS,
        ({ poleMasters }) => {
          if (!this.isReady) { return }
          if (!poleMasters) { return }
          poleMasters.forEach(pm => {
            // プロパティだけ差し替える.
            // なんとこれでリストの表示が更新されるので便利だ.
            const target = this.poleMasterMap[pm.pole_number]
            target.is_attached = pm.is_attached
            target.attached_pole_id = pm.attached_pole_id
            // 選択を解除
            Vue.delete(this.selectedPoleMastersMap, pm.pole_number)
          })
          // 完了数を更新
          this.updateCounts()
        }
      )
    },
    scrollToItemByPole(pole) {
      if (!pole.pole_number) { return }
      const pm = this.poleMasterMap[pole.pole_number]
      if (!pm) {
        console.warn('scrollToItemByPole. poleMaster not found for ', pole)
        return
      }

      // select roadname
      if (this.selectedRoadName !== pm.road_name) {
        this.selectedRoadName = pm.road_name
        this.onChangeRoadName()
      }

      // scroll
      setTimeout(() => {
        window.scrollManager.scrollTo(
          '#' + this.listItemId(pm),
          200,
          {
            offset: -10,
            container: '#' + this.listWrapId,
          }
        )
      }, 0)
    },
    itemDisp(e) {
      if (this.dispType === 'short1') {
        return this.shortItemDisp1(e)
      } else {
        return 'Wrong disp type'
      }
    },
    shortItemDisp1(e) {
      return `
        <div class="item-disp">
          <p class="item-disp-row row1">
            【${e.pole_number}】
            <span class="road-name">${e.road_name}</span>
            <span class="road-section-type">${e.road_section_type}</span>
          </p>
          <p class="item-disp-row row2">
            方向: <span class="direction mr6">${e.direction}</span>
            kp1: <span class="kp mr6">${e.kp1}</span>
            <span v-if="e.kp2">kp2: <span class="kp">${e.kp2}</span></span>
          </p>
          <p class="item-disp-row row3">
            <span class="mr6">左右: ${e.side_type}</span>
            <span>ｿｰﾄ番号: ${e.sort_key1}</span>
          </p>
          <p class="item-disp-row row4">
            登録番号: ${e.register_id}
          </p>
        </div>
      `
    },
    convPoleMasters(arr) {
      const poleMastersAll = {}
      const roadNameMap = {}
      const poleMasterMap = {}
      for (const e of arr) {
        const roadName = e.road_name
        roadNameMap[roadName] = 1

        if (!poleMastersAll[roadName]) {
          poleMastersAll[roadName] = []
        }
        poleMastersAll[roadName].push(e)

        poleMasterMap[e.pole_number] = e
      }

      const roadNames = Object.keys(roadNameMap).sort((a, b) => {
        let v1 = a
        let v2 = b
        const m1 = a.match(/高速(\d+)号/)
        const m2 = b.match(/高速(\d+)号/)
        if (m1 && m2) {
          v1 = parseInt(m1[1])
          v2 = parseInt(m2[1])
        }
        return v1 < v2 ? -1 : (v1 > v2 ? 1 : 0)
      }).map(e => {
        return {
          key: e,
          val: '路線名: ' + e
        }
      })

      return {
        poleMastersByRoadName: poleMastersAll,
        poleMasterMap,
        roadNames
      }
    },
    onChangeRoadName() {
      this.currentPage = 1
      this.updateFilteredPoleMasters()
      const elem = document.getElementById(this.listWrapId)
      elem.scroll(0, 0)

      const roadName = this.selectedRoadName
      this.stream.send(eventNames.CHANGE_ROAD_NAME, { roadName })
      this.$store.dispatch(
        'localStorage/set',
        {
          key: 'selectedRoadNamePoleMaster',
          val: roadName,
        }
      )
    },
    onChangePage(page) {
      this.currentPage = page
      this.setDisplayedPoleMasters()
      const elem = document.getElementById(this.listWrapId)
      elem.scroll(0, 0)
    },
    updateFilteredPoleMasters() {
      const arr = this.poleMastersByRoadName[this.selectedRoadName]
      this.filteredPoleMasters = this.sortedArrayBy(arr,
        [
          { prop: 'sort_key1', sortState: this.sort.sortKey1.state },
        ])
      this.updateCounts()
      this.setDisplayedPoleMasters()
    },
    setDisplayedPoleMasters() {
      const startIdx = this.itemsPerPage * Math.max(this.currentPage - 1, 0)
      this.displayedPoleMasters = this.filteredPoleMasters.slice(
        startIdx, startIdx + this.itemsPerPage)
      this.stream.send(eventNames.CHANGE_POLE_MASTERS,
        { poleMasters: this.displayedPoleMasters })
    },
    updateCounts() {
      this.countInfo.totalCount = this.filteredPoleMasters.length
      this.countInfo.doneCount =
        this.filteredPoleMasters.filter(pm => {
          return pm.is_attached
        }).length
    },
    onListItemClick(pm) {
      if (this.selectedPoleMastersMap[pm.pole_number]) {
        // 今選択されてたものがクリックされたので紐付け解除
        this.stream.send(eventNames.UNSELECT_POLE_MASTERS,
          {
            poles: Object.values(this.selectedPolesMap),
            poleMasters: [pm]
          }
        )
        return
      } else if (pm.is_attached) {
        // 紐付け済のものがクリックされたらそれのみを通知
        this.stream.send(eventNames.SELECT_POLE_MASTERS,
          {
            poles: [],
            poleMasters: [pm]
          }
        )
        return
      }

      // ポールが選択されてなければここで終了
      if (this.isSelectedPolesEmpty) { return }

      // 選択がある状態で別のやつをクリックしたので
      // 元々選択されてたやつを紐付け解除用の配列に保存
      let oldPoleMasters = []
      if (!this.isSelectedPoleMastersEmpty) {
        oldPoleMasters = Object.values(this.selectedPoleMastersMap)
      }

      // select
      this.stream.send(eventNames.SELECT_POLE_MASTERS,
        {
          poles: Object.values(this.selectedPolesMap),
          poleMasters: [pm],
          oldPoleMasters,
        }
      )
    },
    clearPoleMasterSelections() {
      this.selectedPoleMastersMap = {}
    },
    setPoleMasterSelections(poles) {
      this.selectedPoleMastersMap = poles
        .filter(e => !!e.pole_number)
        .reduce((acc, e) => {
          const pole = this.poleMasterMap[e.pole_number]
          if (!pole) { return acc }
          acc[e.pole_number] = pole
          return acc
        }, {})
    },
    onSortKey1Sort({ sortState }) {
      this.sort.sortKey1.state = sortState
      this.updateFilteredPoleMasters()
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-select {
  width: 67%;
}
.sort-bt1 {
  width: 30%;
}
.count-info {
  font-size: 0.9rem;
}
</style>
